module.exports = __webpack_public_path__ + "img/l_h5.45dc12cc.png";